import { router } from "@inertiajs/react";
import { Button, Modal, Select, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useYearContext } from "../../hooks/useYearContext";
import { generateReportTypeRoute, getReportTypeOptions } from "../../models/enums/reportType";
import { type Group, getGroupOptions } from "../../models/group";

type MassReportGeneratorProps = {
  close: () => void;
  opened: boolean;
  groups?: Group[];
};

export function ReportGeneratorModal({ close, opened, groups = [] }: MassReportGeneratorProps) {
  const { pathWithYearContext } = useYearContext();
  const form = useForm({
    mode: "controlled",
    initialValues: {
      group_id: "",
      report_type: "",
    },
    validate: {
      group_id: (value) => (value ? null : "must be present"),
      report_type: (value) => (value ? null : "must be present"),
    },
  });

  const onSubmit = () => {
    router.post(pathWithYearContext(generateReportTypeRoute[form.getValues().report_type]), form.getValues());
    form.reset();
    close();
  };

  return (
    <Modal title="Berichte erstellen" opened={opened} onClose={close}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack>
          <Select
            withAsterisk
            label="Typ"
            clearable
            data={getReportTypeOptions()}
            key={form.key("report_type")}
            {...form.getInputProps("report_type")}
          />
          <Select
            withAsterisk
            label="Gruppe"
            clearable
            data={getGroupOptions(groups)}
            key={form.key("group_id")}
            {...form.getInputProps("group_id")}
          />
          <Button disabled={!form.isValid()} type="submit">
            Generieren
          </Button>
        </Stack>
      </form>
    </Modal>
  );
}
